define('views/conversations/Podio.Views.Conversations.Chat.Show',['require','translate','underscore','jquery','views/conversations/Podio.Views.Conversations.Base.Show','lib/Podio.Router','lib/Podio.Routes','lib/Podio.Event','bowser','jst!conversations/chat/_header','jst!conversations/chat/_message','jst!conversations/chat/_header_details'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewConversationsShowBase = require('views/conversations/Podio.Views.Conversations.Base.Show');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');
  var PodioEvent = require('lib/Podio.Event');
  var browser = require('bowser');

  var jstHeader = require('jst!conversations/chat/_header');
  var jstMessage = require('jst!conversations/chat/_message');
  var jstHeaderDetails = require('jst!conversations/chat/_header_details');

  return ViewConversationsShowBase.extend({
    className: 'inner',

    podioEvents : {
      'click .header .actions .add-people': 'onAddPeopleClicked',                     /* in base */
      'click .header .actions .leave-conversation': 'onLeaveConversationClicked',     /* in base */
      'click .header .actions .mark-unread': 'onMarkUnreadClick',                     /* in base */
      'click .header .star': 'onStarClick',                                           /* in base */
      'click .header .unstar': 'onUnstarClick',                                          /* in base */
      'click .header .new-conversation': 'onNewConversationClicked'
    },

    initialize: function() {
      _.bindAll(this, 'renderEvent');

      this.elmTarget = this.options.elmTarget;
      this.elmWindow = $(window);

      // Infinite Scroll View settings
      this.reverseScroll = true;

      this._super();

      this._bindEvents();
    },

    _bindConversationEvents: function() {
      this.listenTo(this.collection, 'add', this.renderEvent);
    },

    _getActionEntries: function() {
      var actionEntries = [];

      // Most of the actions are only possible on a created conversation, not on an unsaved one
      if (this.model.get('id')) {
        actionEntries.push({iconClass: 'icon-16-task', label: t('Assign task #conversations'), href: '#', linkClass: 'task-context-create assign-task', extra_attributes: { 'data-ref_type': 'conversation', 'data-ref_id': this.model.get('id') } });

        if (this.model.canLeaveConversation()) {
          actionEntries.push({iconClass: 'icon-16-user-minus-red', label: t('Leave conversation #conversations'), href: '#', linkClass: 'leave-conversation' });
        }

        if (!this.model.isUnread()) {
          actionEntries.push({iconClass: 'icon-16-unread-dot', label: t('Mark as unread #conversations'), href: '#', linkClass: 'mark-unread' });
        }

        if (this.model.isStarred()) {
          actionEntries.push({iconClass: 'icon-16-star', label: t('Unstar this #conversations'), href: '#', linkClass: 'unstar' });
        } else {
          actionEntries.push({iconClass: 'icon-16-star-hollow', label: t('Star this #conversations'), href: '#', linkClass: 'star' });
        }
      }

      actionEntries.push({
        iconClass: 'icon-16-grey-inbox',
        label: t('Go to inbox #conversations'),
        href: routes.html_conversations_path({format: 'html', anchor: this.model.id}),
        linkClass: 'go-to-inbox'
      });

      return actionEntries;
    },

    _bindEvents: function() {
      PodioEvent.bind('resize', this.onWindowResize, this);
    },

    onWindowResize: _.debounce(function() {
      this._adjustHeight();
    }, 50),

    renderHeader: function() {
      var html = this.getTemplate(jstHeader, {
        conversation: this.model,
        actionEntries: this._getActionEntries(),
        translations: {
          close: t('Close #chatpane'),
          startVideo: t('Start video conversation #chat.video'),
          startAudio: t('Start audio conversation #chat.audio'),
          addPeople: t('Add connections #contact_app_type'),
          newConversation: t('New conversation #conversations'),
          directConversation: t('Direct conversation #conversations'),
          addSubject: t('Edit subject #conversations')
        },
        jstHeaderDetails: jstHeaderDetails
      });

      if (this.elmHeader) {
        this.elmHeader.replaceWith(html);
      } else {
        this.elm.html(html);
      }

      this.elmHeader = this.elm.find('.header-wrapper');

      this._initInlineEditor();
    },

    renderEvent: function(event, col, options) {
      this._super(event, col, options, jstMessage);
    },

    renderComposer: function(options) {
      options = _.extend({
        returnSubmit: true,
        hideSubmitButton: true,
        disableTabIndex: true
      }, options || {});

      this._super(options);
    },

    render: function(customTemplate, options) {
      this.renderHeader();

      // (Rendering of composer, and other UI components, happens inside .super)
      this._super(customTemplate, options);

      // UI tweaks
      this._adjustHeight();
      this._initInfiniteScroll();

      return this;
    },

    scrollToBottom: function() {
      if (browser.webkit) {
        this.reflowForWebkit();
      }

      this._super();
    },

    reflowForWebkit: function() {
      // to get rid of a rendering bug in Chrome we need to reflow here
      var elmColumn = this.elmEventsContainer.parents('.column.details');

      elmColumn.css('height', 'auto');

      _.delay(function() {
        elmColumn.css('height', '100%');
      }, 200);
    },

    renderEmpty: function() {
      this.elmTarget.html('');
    },

    setConversation: function(conversation, collection) {
      this.model = conversation;
      this.collection = collection;

      this.stopListening();
      this._bindConversationEvents();
    },

    dispose: function() {
      if (this.elmItemsContainer) {
        this.disposePagination();
      }

      if (this.composerView) {
        this.composerView.dispose();
      }

      PodioEvent.unbind(undefined, undefined, this);

      this._super();
    },

    onNewConversationClicked: function(targetElm, event) {
      this.eventBus.trigger('newConversation:click', this.model);
    }
  });
});

